import React from 'react';
import Badge from '@mui/material/Badge';

export default React.memo(Badge);
